import { createBrowserRouter, redirect } from 'react-router-dom';
import { withProtected } from './withProtected';
import { withFeatureFlag } from './withFeatureFlag';
import Profile from '../pages/Profile';
import Edit from '../pages/Profile/Edit';
import View from '../pages/Profile/View';

// University

import Sharing from '../pages/Sharing';
import { lazyWithRetry as lazy } from './lazyWithRetry';

import { admin } from './admin';
import { organisation } from './organisation';
import { wallet } from './wallet';
import { verification } from './verification';
import { sharedWallet } from './sharedWallet';
import { product } from './product';
import { myJourney } from './myJourney';
import { portal } from './portal';
import { advisorSupport } from './advisorSupport';
import { resourceHub } from './resourceHub';
import TotpRecovery from '../pages/TotpRecovery';
import ProtectedLayout from './ProtectedLayout';
// import Preferences from '../pages/Preference/Preferences';

const router = createBrowserRouter([
	{
		path: '/login',
		Component: lazy(() => import('../pages/Login'))
	},
	{
		path: '/sharing/:sharingId',
		Component: Sharing
	},
	{
		path: '/totpRecovery/:token',
		Component: TotpRecovery
	},
	{
		path: '/error',
		Component: lazy(() => import('../pages/Error'))
	},
	{
		// Layout route — MainLayout stays mounted for all protected child routes
		Component: ProtectedLayout,
		children: [
			{
				path: '/',
				Component: withProtected(lazy(() => import('../pages/Dashboard')))
			},
			{
				path: '/logout',
				Component: withProtected(lazy(() => import('../pages/Logout')))
			},
			{
				path: '/preferences',
				Component: withProtected(lazy(() => import('../pages/Preference/Preferences')))
			},
			{
				path: '/faq',
				Component: withFeatureFlag(withProtected(lazy(() => import('../pages/Faq/Faq'))), 'faq-enabled')
			},
			{
				path: '/profile',
				Component: withProtected(Profile),
				handle: {
					label: 'Profile',
					key: 'pages.profile.title'
				},
				children: [
					{
						path: '/profile/',
						Component: View,
						handle: {
							key: 'pages.profile.view.title'
						}
					},
					{
						path: '/profile/edit',
						Component: Edit,
						handle: {
							key: 'pages.profile.edit.title'
						}
					}
				]
			},
			{
				path: '/users/:id/',
				Component: withProtected(lazy(() => import('../pages/User')))
			},
			{
				path: '/payment/success',
				Component: withProtected(lazy(() => import('../pages/PaymentSuccess')))
			},
			{
				path: '/badges',
				Component: withProtected(lazy(() => import('../pages/Badges'))),
				handle: {
					key: 'pages.badges.title'
				}
			},
			...wallet,
			...verification,
			...admin,
			...organisation,
			...sharedWallet,
			...product,
			...myJourney,
			...portal,
			...advisorSupport,
			...resourceHub,
			{
				path: '/ana',
				Component: withProtected(lazy(() => import('../pages/Ana'))),
				handle: {
					key: 'pages.aiAssistant.ana'
				}
			},
			{
				path: '/agent/',
				Component: withFeatureFlag(withProtected(lazy(() => import('../pages/Agent'))), 'agent-enabled'),
				handle: {
					key: 'pages.agent.title'
				},
				children: [
					{
						path: '/agent/',
						Component: lazy(() => import('../pages/Agent/View'))
					},
					{
						path: '/agent/edit',
						Component: lazy(() => import('../pages/Agent/Update')),
						handle: {
							// `pages.agent.update.*` is the translated node, matching the
							// Update component. The key said `edit`, which does not exist, so
							// the breadcrumb rendered the raw path (same defect as PTEC-580).
							key: 'pages.agent.update.title'
						}
					}
				]
			},
			{
				path: '/404',
				Component: lazy(() => import('../pages/NotFound'))
			},
			{
				path: '*',
				Component: lazy(() => import('../pages/NotFound'))
			}
		]
	},
	{
		path: '/404',
		Component: lazy(() => import('../pages/NotFound'))
	},
	{
		path: '*',
		loader: (params) => {
			console.warn('Not found', params.request.url);
			return redirect('/404');
		}
	}
]);

export default router;
